import React, { PropTypes as T } from 'react';
import axios from 'axios';
import { FileDrop } from 'react-file-drop';

import { timeout } from '../../utils/helper-functions';
import { reportError } from '../../utils/error-handling-service';

class Uploader extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      progress: 0,
      fileName: '',
    };
  }

  onDragOver(event) {
    this.props.updateUploaderState(2);
  }

  onDragLeave(event) {
    this.props.updateUploaderState(1);
  }

  resetUploader() {
    this.props.updateUploaderState(1);
  }

  getSignedUrl(file, timestamp) {
    try {
      const endpoint = process.env.REACT_APP_CREATE_UPLOAD_URL_API;
      const payload = {
        data: {
          filepath: `${timestamp
          }-${
            file.name.replace(/(?:[^\w?.]+_*|_+)+/g, '_')}`,
          contentType: file.type ? file.type : 'text/plain',
        },
      };
      const headers = {};

      return axios.post(endpoint, payload, headers);
    } catch (error) {
      reportError('GET_FILE_SIGNED_URL_ERROR', error.message);
    }
  }

  checkUploadSuccess(fileName, timestampFormatted) {
    try {
      const endpoint = `${process.env.REACT_APP_CHECK_FILE_EXISTS_API}/processed${timestampFormatted}${fileName}`;
      const headers = {};

      return axios.get(endpoint, headers);
    } catch (error) {
      reportError('CHECK_FILE_UPLOAD_ERROR', error.message);
    }
  }

  uploadToS3(url, file) {
    try {
      const context = this;
      const options = {
        headers: {
          'Content-Type': file.type ? file.type : 'text/plain',
        },
        onUploadProgress(progressEvent) {
          const progressPercentage =
            progressEvent.loaded / progressEvent.total * 100;
          const progressRounded = Math.round(progressPercentage);

          context.setState({ progress: progressRounded });
        },
      };

      return axios.put(url, file, options);
    } catch (error) {
      reportError('UPLOAD_FILE_TO_S3_ERROR', error.message);
    }
  }

  async onDrop(files, event) {
    // this.setState({ uploader: 3 });
    this.props.updateUploaderState(3);
    const file = files[0];

    let url = null;
    const time = new Date();
    const timestamp = time.getTime();

    await this.getSignedUrl(file, timestamp).then(response => {
      url = response.data.body.url;
      // this.setState({ uploader: 4 });
      this.props.updateUploaderState(4);
    });

    const responseData = await this.uploadToS3(url, file).then(response => {
      // this.setState({ uploader: 5 });
      this.props.updateUploaderState(5);
      return response.config.data;
    });

    const context = this;
    const fileName = file.name.replace(/(?:[^\w?.]+_*|_+)+/g, '_');
    const fileType = responseData.type;
    const docType = this.props.docType;
    const size = responseData.size;
    const timestampFormatted = `-${timestamp}-`;

    await timeout(3000);

    await context
      .checkUploadSuccess(fileName, timestampFormatted)
      .then(response => {
        const documentData = {
          name: fileName,
          docType,
          fileType,
          filePath: `processed${timestampFormatted}${fileName}`,
          size,
        };

        // Call callback here with the data
        this.props.uploadDataCallback(documentData);

        context.setState({ fileName, documentData });
        this.props.updateUploaderState(6);
      })
      .catch(error => {
        this.props.updateUploaderState(7);
      });
  }

  async onSelect(event) {
    this.props.updateUploaderState(3);
    const path = event.target.value;
    const selectedFile = event.target.files[0];

    let url = null;
    const time = new Date();
    const timestamp = time.getTime();

    await this.getSignedUrl(selectedFile, timestamp).then(response => {
      url = response.data.body.url;
      // this.setState({ uploader: 4 });
      this.props.updateUploaderState(4);
    });

    const responseData = await this.uploadToS3(
      url,
      selectedFile,
    ).then(response => {
      // this.setState({ uploader: 5 });
      this.props.updateUploaderState(5);
      return response.config.data;
    });

    const context = this;
    const fileName = selectedFile.name.replace(/(?:[^\w?.]+_*|_+)+/g, '_');
    const fileType = responseData.type ? responseData.type : 'text/plain';
    const docType = this.props.docType;
    const size = responseData.size;
    const timestampFormatted = `-${timestamp}-`;

    await timeout(3000);

    await context
      .checkUploadSuccess(fileName, timestampFormatted)
      .then(response => {
        const documentData = {
          name: fileName,
          docType,
          fileType,
          filePath: `processed${timestampFormatted}${fileName}`,
          size,
        };

        // context.setState({ uploader: 6, fileName, documentData });
        context.setState({ fileName, documentData });
        this.props.updateUploaderState(6);

        // Call callback here with the data
        this.props.uploadDataCallback(documentData);
      })
      .catch(error => {
        this.props.updateUploaderState(7);
      });
  }

  render() {
    const { uploaderState } = this.props;
    const uploaderDisplay = uploaderState === 6 ? 'display' : '';

    return (
      <div className={`uploader ${uploaderDisplay}`}>
        <FileDrop
          frame={document}
          onDragOver={this.onDragOver.bind(this)}
          onDragLeave={this.onDragLeave.bind(this)}
          onDrop={this.onDrop.bind(this)}
          targetAlwaysVisible
        />
        <div className="uploader-content">
          { uploaderState === 1 &&
            <div className="uploader-center">
              <img src="/icons/upload.svg" alt="upload" />
              <div className="spacer" />
              <p>upload file</p>
            </div>
          }
          { uploaderState === 2 &&
            <div className="uploader-center">
              <img src="/icons/drop.svg" alt="upload" />
              <div className="spacer" />
              <p>drop anywhere to upload</p>
            </div>
          }
          { uploaderState === 3 &&
            <div className="uploader-center">
              <div className="processing-spinner" />
              <div className="spacer" />
              <p>&nbsp;&nbsp;</p>
            </div>
          }
          { uploaderState === 4 &&
            <div className="uploader-center">
              <div className="uploading-spinner" />
              <div className="spacer" />
              <p>uploading... {this.state.progress}%</p>
            </div>}
          { uploaderState === 5 &&
            <div className="uploader-center">
              <div className="processing-spinner" />
              <div className="spacer" />
              <p>processing...</p>
            </div>
          }
          { uploaderState === 6 &&
            <div className="uploader-center">
              <div className="uploaded-document">
                <div className="left">
                  <img
                    src="/icons/generic-document.svg"
                    alt="uploaded document"
                  />
                </div>
                <div className="center">
                  <p>{ this.state.fileName }</p>
                </div>
                <div className="right">
                  <img src="/icons/close-small.svg" alt="close" onClick={this.resetUploader.bind(this)} />
                </div>
              </div>
            </div>
          }
          { uploaderState === 7 &&
            <div className="uploader-center">
              <img src="/icons/error.svg" alt="upload error" />
              <div className="spacer" />
              <p className="black">
                upload failed
                <span className="absolute">
                  <a onClick={this.resetUploader.bind(this)}>Retry</a>
                </span>
              </p>
            </div>
          }
        </div>
        { uploaderState !== 6 && uploaderState !== 7 &&
          <div>
            <input
              type="file"
              className="uploader"
              id="uploader"
              ref="uploader"
              onChange={this.onSelect.bind(this)}
            />
            <label htmlFor="uploader" />
          </div>
        }
      </div>
    );
  }
}

export default Uploader;



/** WEBPACK FOOTER **
 ** ./src/components/uploader/index.js
 **/